import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AdminHotelNavbarComponent } from '../../../../components/admin-hotel-navbar/admin-hotel-navbar.component';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductosService } from '../../../../services/productos.service';
import { TokenStorageService } from '../../../../services/token-storage.service';
import { NavbarComponent } from "../../../../components/navbar/navbar.component";

@Component({
  selector: 'app-editar-producto',
  imports: [AdminHotelNavbarComponent, FooterComponent, CommonModule, ReactiveFormsModule, NavbarComponent],
  templateUrl: './editar-producto.component.html',
  styleUrl: './editar-producto.component.css'
})
export class EditarProductoComponent implements OnInit {
  productoForm!: FormGroup;
  alojamientoId: string = '';
  alojamientoName: string = '';
  productoId: string = '';
  cargando = true;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private productosService: ProductosService,
    private tokenStorage: TokenStorageService
  ) { }

  ngOnInit(): void {
    this.productoForm = this.fb.group({
      nombre: [''],
      descripcion: [''],
      precio: [''],
      impuesto: [''],
      stock: [''],
    });

    this.route.paramMap.subscribe(params => {
      this.productoId = params.get('id') || '';
    });

    this.route.queryParamMap.subscribe(params => {
      this.alojamientoId = params.get('alojamientoId') || '';
      this.alojamientoName = params.get('alojamientoName') || '';
    });

    if (this.productoId) {
      this.cargarProducto(this.productoId);
    }
  }

  cargarProducto(id: string) {
    this.productosService.obtenerProducto(id, this.alojamientoId, this.tokenStorage.getAccessToken() || '').subscribe({
      next: data => {
        console.log('producto: ', data);
        this.productoForm.patchValue({
          nombre: data.name,
          descripcion: data.description,
          precio: data.price,
          impuesto: data.tax_rate,
          stock: data.stock,
        });
        this.cargando = false;
      },
      error: err => {
        console.error('Error cargando producto:', err);
        this.cargando = false;
      }
    });
  }

  guardarCambios() {
    if (this.productoForm.invalid) return;

    const payload = {
      productId: this.productoId,
      hotelId: this.alojamientoId,
      name: this.productoForm.value.nombre,
      description: this.productoForm.value.descripcion,
      price: this.productoForm.value.precio,
      tax_rate: this.productoForm.value.impuesto,
      stock: this.productoForm.value.stock,
    };

    this.productosService.editarProducto(payload, this.alojamientoId, this.tokenStorage.getAccessToken() || '').subscribe({
      next: () => {
        alert('Producto actualizado con éxito');
        this.router.navigate(['/admin-hotel/inventario/gestionar-productos'], {
          queryParams: {
            alojamientoId: this.alojamientoId,
            alojamientoName: this.alojamientoName,
          }
        });
      },
      error: err => console.error('Error al actualizar producto:', err)
    });
  }
}
